/**************************************************
 * Nombre:       Dialogo_Despacho
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {Delete} from "@mui/icons-material";
import {borrarDoc} from "../../Servicios/BD/borrarDoc";
import Formulario_Adicional from "../Formularios/Formulario_Adicional";
import {theme} from "../../Tema";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import {guardarFechaAct} from "../../Servicios/BD/Actualizadores/guardarFechaAct";

const Dialogo_Adicionales = ({datos, cerrar, realizado}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Cargador, iniciarCarga, setDetener, Avisos, terminar, nuevoAviso} = useCargador({
        logo: logo,
        funcionUno: cerrar,
        funcionDos: realizado
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        iniciarCarga('Guardando Datos')
        entidad.fecha = new Date().getTime()

        let dox = await guardarDoc('politicas', entidad)
        await guardarFechaAct('politicas')
        if (dox.res) {
            terminar({aviso: 'Datos subidos con exito'})
        } else {
            terminar({aviso: 'Algo sali mal, por favor intetalo nuevamente', variante: 'error'})
        }


    }

    const borrar = async () => {
        await borrarDoc('politicas', datos.id)
        terminar({aviso: 'Politica borrado'})
    }
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Adicional props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>

            {datos && datos.id &&
                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        sx={{color: theme.palette.primary.main, px: 1}}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid>
            }


        </Grid>
    )

}
export default Dialogo_Adicionales